import { render, staticRenderFns } from "./paper-preferences.html?vue&type=template&id=1b6d9c64&scoped=true&external"
import script from "./paper-preferences.js?vue&type=script&lang=js&external"
export * from "./paper-preferences.js?vue&type=script&lang=js&external"
import style0 from "./paper-preferences.scss?vue&type=style&index=0&id=1b6d9c64&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6d9c64",
  null
  
)

export default component.exports